import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  name: "addModule",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      formModel: {
        mod_name: null,
        state: 1,
        code: '',
        //模块代码
        mod_desc: null
      },
      formRules: {
        mod_name: [{
          required: true,
          message: '请输入模块名',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入模块代码',
          trigger: 'blur'
        }],
        mod_desc: [{
          required: true,
          message: '请输入说明',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          type: 'number',
          message: '请选择状态',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {}
  },
  components: {},
  computed: {},
  methods: {},
  mounted: function mounted() {},
  created: function created() {
    if (this.edit) {
      Object.assign(this.formModel, this.setData);
    }
  }
};